import { Component, Input, OnInit } from '@angular/core';
import { BienesRaicesText } from 'src/app/models/bienes-raices/bienes-raices.model';

export interface InformacionBasicaElement {
  name: string;
  value: any;
}

export interface TableBienesRaicesElement {
  rol_predio: string;
  rol_manzana: string;
  cod_comuna: string;
  direccion: string;
  comuna: string;
  ciudad: string;
  region: string;
  serie: string;
  ubicacion: string;
  destino: string;
  avaluo_exento: string;
  anio_exencion: string;
  total_a_pagar: string;
  avaluo_total: string;
}

@Component({
  selector: 'app-bienes-raices-viewer',
  templateUrl: './bienes-raices-viewer.component.html',
  styleUrls: ['./bienes-raices-viewer.component.scss']
})
export class BienesRaicesViewerComponent implements OnInit {
  @Input() content: any = null;
  @Input() showHeader: boolean = true;
  @Input() fromConsolidado: boolean = false;
  public header: string[] = [
    'rol_predio',
    'rol_manzana',
    'cod_comuna',
    'direccion',
    'comuna',
    'ciudad',
    'region',
    'serie',
    'ubicacion',
    'destino',
    'avaluo_exento',
    'anio_exencion',
    'total_a_pagar',
    'avaluo_total'
  ];

  public BienesRaicesText: any = BienesRaicesText;
  public datosBasicos: InformacionBasicaElement[] = [];
  public tableBienesRaices: TableBienesRaicesElement[] = [];
  displayedColumns: string[] = ['name', 'value'];
  displayedColumnsBienesRaices: string[] = [
    'rol_predio',
    'rol_manzana',
    'cod_comuna',
    'direccion',
    'comuna',
    'ciudad',
    'region',
    'serie',
    'ubicacion',
    'destino',
    'avaluo_exento',
    'anio_exencion',
    'total_a_pagar',
    'avaluo_total'
  ];

  public today: string = '';
  public rut: string = '';

  constructor() {}


  ngOnInit(): void {
    this.setDatosBasicos();
    this.setTableBienesRaices();
    this.setToday();
    this.setRut();
  }

  setRut() {
    this.rut = this.content?.bienesraicesReporte?.datosBasicosSolicitud?.Rut + '-' + this.content?.bienesraicesReporte?.datosBasicosSolicitud?.DV
  }

  setDatosBasicos() {
    const rut = this.content?.bienesraicesReporte?.datosBasicosSolicitud?.Rut + '-' + this.content?.bienesraicesReporte?.datosBasicosSolicitud?.DV;
    this.datosBasicos = [
      {name: "Rut", value: rut},
      {name: "Nombre", value: this.content?.bienesraicesReporte?.bienesRaices?.listadoBienesRaices?.[0]?.nombre || ''},
      {name: "Número Total Bienes Raíces", value: this.content?.bienesraicesReporte?.bienesRaices?.listadoBienesRaices.length},
      {name: "Valor Total Bienes Raíces", value: this.getSumaTotal()},
    ];
  }

  getSumaTotal() {
    if(this.content?.bienesraicesReporte?.bienesRaices?.listadoBienesRaices.length || this.content?.bienesraicesReporte?.bienesRaices?.listadoBienesRaices.length == 0) {
      const suma = this.content?.bienesraicesReporte?.bienesRaices?.listadoBienesRaices.reduce((a: any, b: any) => a + this.setNumber(b.avaluo_total), 0);
      return suma / 1000;
    }
    return '';
  }

  setTableBienesRaices(): void {
    this.tableBienesRaices = [];
    if(this.content?.bienesraicesReporte?.bienesRaices?.listadoBienesRaices && this.content?.bienesraicesReporte?.bienesRaices?.listadoBienesRaices.length > 0) {
      
      this.content.bienesraicesReporte.bienesRaices.listadoBienesRaices.forEach((bienRaiz: any) => {
        this.tableBienesRaices.push({
          rol_predio: bienRaiz.rol_predio,
          rol_manzana: bienRaiz.rol_manzana,
          cod_comuna: bienRaiz.cod_comuna,
          direccion: bienRaiz.direccion,
          comuna: bienRaiz.comuna,
          ciudad: bienRaiz.ciudad,
          region: bienRaiz.region,
          serie: bienRaiz.serie,
          ubicacion: bienRaiz.ubicacion,
          destino: bienRaiz.destino,
          avaluo_exento: bienRaiz.avaluo_exento,
          anio_exencion: bienRaiz.anio_exencion,
          total_a_pagar: bienRaiz.total_a_pagar,
          avaluo_total: bienRaiz.avaluo_total
        });
      });
    }
  }

  setNumber(num: string): number {
    return Number(num);
  }

  setToday() {
    this.today = `${new Date().getFullYear()}${(new Date().getMonth() + 1 < 10?  '0'+(new Date().getMonth() + 1) : 
      new Date().getMonth() + 1)}${new Date().getDate()}`;        
  }

}
